import { useQuery } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';

import c from '../utils/constants';

export default function useGetPublicBookingEventAvailabilityDate(
  id: string,
  month: string,
  year: string,
) {
  const { state } = useProvider();
  const args = state;
  return useQuery({
    queryKey: [c.BOOKING_EVENT_AVAILABILITY_DATE, id, month, year],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get({
        url: `api/public/calendar/moments/events/${id}/dates?month=${month}&year=${year}`,
      });

      return data?.data;
    },
    enabled: !!id && !!month && !!year,
    retry: false,
  });
}
